import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BranchAvatarModule } from '@portal-core/branches/components/branch-avatar/branch-avatar.module';
import { BranchesSelectListModule } from '@portal-core/branches/components/branches-select-list/branches-select-list.module';
import { BranchAsyncModule } from '@portal-core/branches/pipes/branch-async/branch-async.module';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { NoItemPlaceholderModule } from '@portal-core/general/components/no-item-placeholder/no-item-placeholder.module';
import { ProjectChecklistColumnsFormModule } from '@portal-core/project-checklists/components/project-checklist-columns-form/project-checklist-columns-form.module';
import { ProjectChecklistRowsFormModule } from '@portal-core/project-checklists/components/project-checklist-rows-form/project-checklist-rows-form.module';
import { ProjectChecklistSettingsFormModule } from '@portal-core/project-checklists/components/project-checklist-settings-form/project-checklist-settings-form.module';
import { ProjectChecklistTypeDisplayTextModule } from '@portal-core/project-checklists/pipes/project-checklist-type-display-text/project-checklist-type-display-text.module';
import { ProjectFilesTreeModule } from '@portal-core/project-files/components/project-files-tree/project-files-tree.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { ChecklistTemplateCreateDialogComponent } from './checklist-template-create-dialog.component';

@NgModule({
  declarations: [
    ChecklistTemplateCreateDialogComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    FormControlErrorMessageModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSnackBarModule,
    ProjectChecklistSettingsFormModule,
    ProjectChecklistColumnsFormModule,
    ProjectChecklistRowsFormModule,
    MatListModule,
    MatProgressBarModule,
    MatSelectModule,
    MatStepperModule,
    MatToolbarModule,
    MatTooltipModule,
    NoItemPlaceholderModule,
    ProjectAvatarModule,
    ReactiveFormsModule,
    BranchesSelectListModule,
    BranchAsyncModule,
    BranchAvatarModule,
    ProjectFilesTreeModule,
    AutocompleteInputModule,
    ProjectChecklistTypeDisplayTextModule,
    ProjectAsyncModule
  ],
  exports: [
    ChecklistTemplateCreateDialogComponent
  ]
})
export class ChecklistTemplateCreateDialogModule { }
